import { UserTicketInterface } from '../user-ticket.interface';

export interface UserTicketUpcomingPastFilteredInterface {
  upcoming?: UserTicketInterface[];
  past?: UserTicketInterface[];
}
